import { PRODUCT_STATUS_MAP } from '@/utils/const'
export const getSubItemById = (list, id) => {
  return list.filter(item => {
    item.id === id
  })
}

/**
 * 判断是否全选
 * @param {Array<mall.CommonProductInfo>} goods 正常活动商品
 * @param {Array<mall.CommonProductInfo>} discountList 多件多折商品
 * @returns
 */
export const isSelectAll = (goods, discountList) => {
  const list1 = Array.isArray(goods) ? goods : []
  const list2 = Array.isArray(discountList) ? discountList : []
  const list = list1.concat(list2)
  if (list.length < 1) return false

  for (let i = 0, len = list.length; i < len; i++) {
    const { selected, status } = list[i]
    if (selected === false && status !== PRODUCT_STATUS_MAP.PRE_SELL) return false
  }

  return true
}

//获取所有的subItemId
export const getAllSelectedSubItemId = list => {
  const res = []
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i].status !== PRODUCT_STATUS_MAP.PRE_SELL) {
      res.push(list[i].subItemId)
    }
  }
  return res
}

//格式化数据
export const formatCartList = list => {
  if (!Array.isArray(list) || list.length < 1) return []
  return list.map(item => {
    return {
      ...item,
      selectedSubItem: {
        ...item.selectedSubItem,
        count: item.count,
      },
      originCount: item.count, //为了处理直接修改数量，无法得到两个数量的差值
    }
  })
}

/**
 * 记录所有的商品
 * @param {Array<mall.CommonProductInfo>} goods 正常活动商品
 * @param {Array<mall.CommonProductInfo>} discountList 多件多折商品
 * @returns
 */
export const handleCartData = (goods, discountList) => {
  const list1 = Array.isArray(goods) ? goods : []
  const list2 = Array.isArray(discountList) ? discountList : []
  const list = list1.concat(list2)
  if (list.length < 1) return {}
  const selectedSubItemIds = []
  const reportDatas = []
  for (let i = 0, len = list.length; i < len; i++) {
    const { status, subItemId, itemId, count } = list[i]
    reportDatas.push({
      itemId,
      subItemId,
      subItemCount: count,
    })
    if (status !== PRODUCT_STATUS_MAP.PRE_SELL) {
      selectedSubItemIds.push(subItemId)
    }
  }

  return {
    selectedSubItemIds: selectedSubItemIds,
    reportDatas: reportDatas,
  }
}

// /**
//  * 获取选中商品信息
//  * @param {*} list
//  */
// export const getSelectedItems = list => {
//   // if (!Array.isArray(list) || list.length < 1) return []
//   const keys = list
//   return list.filter(item => {
//     return item.selected
//   })
// }
